import { SUPPORTED_EXCHANGES } from "@cede/types";

const DEFAULT_CDN = "https://cdn.cedelabs.io/token";

type TokenIconAdapter = (baseAsset: string) => string;

function stripSuffixes(baseAsset: string): string {
  return baseAsset.replace(/-PERP$/, "").replace(/-SWAP$/, "");
}

function stripPrefixAndSuffixes(baseAsset: string): string {
  return baseAsset
    .replace(/^[a-zA-Z]+:/, "")
    .replace(/-PERP$/, "")
    .replace(/-SWAP$/, "");
}

function hyperliquidTokenIcon(baseAsset: string): string {
  const cleaned = stripSuffixes(baseAsset).replace(/^([a-zA-Z]+):/, (_, prefix) => `${prefix.toLowerCase()}:`);
  return `https://app.hyperliquid.xyz/coins/${cleaned}.svg`;
}

function paradexTokenIcon(baseAsset: string): string {
  return `https://app.paradex.trade/static/market/${stripPrefixAndSuffixes(baseAsset)}.svg`;
}

function cedeTokenIcon(baseAsset: string): string {
  return `${DEFAULT_CDN}/${stripPrefixAndSuffixes(baseAsset).toLowerCase()}.svg`;
}

const TOKEN_ICON_ADAPTERS: Partial<Record<string, TokenIconAdapter>> = {
  [SUPPORTED_EXCHANGES.HYPERLIQUID]: hyperliquidTokenIcon,
  [SUPPORTED_EXCHANGES.TRADEXYZ]: hyperliquidTokenIcon,
  [SUPPORTED_EXCHANGES.HYNA]: hyperliquidTokenIcon,
  [SUPPORTED_EXCHANGES.CASH]: hyperliquidTokenIcon,
  [SUPPORTED_EXCHANGES.PARADEX]: paradexTokenIcon,
  [SUPPORTED_EXCHANGES.ZEROONE]: cedeTokenIcon,
};

export function getExchangeTokenIconUrl(exchangeId: string, baseAsset: string): string {
  const adapter = TOKEN_ICON_ADAPTERS[exchangeId];
  return adapter ? adapter(baseAsset) : cedeTokenIcon(baseAsset);
}
